import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import logo from '../../../assets/login_logo.png';

import {
  LoginForm,
  FormInput,
  FormItem,
  LoginFormWrapper,
  FormInputPassword,
  SubmitButtom,
  Description,
  ErrorAlert
} from './styled';

const LeftContainer = ({ initialValues, onSubmit, isSubmitted, error }) => {
  return (
    <LoginFormWrapper>
      <img src={logo} alt="tookitaki" title="logo" />

      <LoginForm
        name="loginForm"
        layout="vertical"
        initialValues={initialValues}
        requiredMark={false}
        onFinish={onSubmit}
        autoComplete="off">
        {error && <ErrorAlert message={error} type="error" />}
        <FormItem
          label="Username*"
          name="username"
          rules={[
            {
              required: true,
              message: 'Username should not be empty'
            }
          ]}>
          <FormInput placeholder="Username" />
        </FormItem>
        <FormItem
          label="Password*"
          name="password"
          rules={[
            {
              required: true,
              message: 'Password should not be empty'
            }
          ]}>
          <FormInputPassword placeholder="Password" />
        </FormItem>
        <Form.Item>
          <SubmitButtom
            loading={isSubmitted}
            disabled={isSubmitted}
            htmlType="submit"
            icon={<LoginOutlined />}
            size="large">
            Login
          </SubmitButtom>
        </Form.Item>
      </LoginForm>

      <Description>
        <p>
          By submitting this form, you consent to using the details you provide
          to respond to your enquiry. A backup of these details will be held,
          but can only be accessed by authorised individuals. If you would like
          your data to be removed from our backups, please email us.
        </p>
      </Description>
    </LoginFormWrapper>
  );
};

LeftContainer.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool,
  error: PropTypes.string
};

export default LeftContainer;
